// User
const USER_URL = `${process.env.REACT_APP_USER_URL || '/api'}${
  process.env.REACT_APP_USE_MOCK === 'true' ? '/mock' : ''
}`;
export const LOGIN = `${USER_URL}/login`;
export const LOGOUT = `${USER_URL}/logout`;

// Public
export const HOME = '';
export const LA_CARTE = 'la-carte';
export const GALERIE = 'galerie';
export const A_PROPOS = 'a-propos';
export const MIDI_COMMANDES = 'midi-commandes';
export const DEVIS_BUFFET = 'devis-buffet';

// Autre
export const ERREUR_TECHNIQUE = 'error';
export const CONTACT = 'contact';
